import FItemString from '../FItem/String';
import component from './component.vue';

export default class FAvatar extends FItemString {
  __component = component;
}
